export const sipCodeExample = {
  nodejs: [
    'const taar = require(\'@taar/telephony\');',
    '',
    'const client = new taar.Client({',
    '  apiKey: process.env.TAAR_API_KEY,',
    '  region: \'in\'',
    '});',
    '',
    '// Provision SIP trunk',
    'const trunk = await client.sip.createTrunk({',
    '  name: \'Production Trunk\',',
    '  capacity: 100',
    '});'
  ],
  python: [
    'import taar',
    '',
    'client = taar.Client(',
    '    api_key=os.environ["TAAR_API_KEY"],',
    '    region="in"',
    ')',
    '',
    '# Provision SIP trunk',
    'trunk = client.sip.create_trunk(',
    '    name="Production Trunk",',
    '    capacity=100',
    ')'
  ],
  curl: [
    'curl -X POST \\',
    '  https://api.taar.ai/v1/sip/trunks \\',
    '  -H "Authorization: Bearer $TAAR_API_KEY" \\',
    '  -H "Content-Type: application/json" \\',
    '  -d \'{',
    '    "name": "Production Trunk",',
    '    "capacity": 100',
    '  }\''
  ]
};

export const monitoringCodeExample = {
  nodejs: [
    '// Monitor real-time calls',
    'const calls = await client.calls.list({',
    '  status: \'active\',',
    '  limit: 100',
    '});',
    '',
    '// Get call analytics',
    'const analytics = await client.analytics.getCallMetrics({',
    '  startDate: \'2024-01-01\',',
    '  endDate: \'2024-01-31\'',
    '});'
  ]
};
